import { gql } from 'graphql-request';
import withFragments from 'utils/graphql';

import ActivityCard from 'fragments/ActivityCard';
import Logo from 'fragments/Logo';

export default withFragments(
  gql`
    query($id: Int, $contentType: String!, $token: String!, $filters: [FilterType], $filterThemeId: Int) {
      page(id: $id, contentType: $contentType, token: $token) {
        id
        url
        title
        slug
        seoTitle
        seoDescription
        ... on ActivityIndex {
          metaImage {
            url
          }
          metaTitle
          metaDescription
          title
          logo {
            ...Logo
          }
        }
      }
      activities(activityIndexId: $id, filters: $filters, themeId: $filterThemeId) {
        ...ActivityCard
        ...CustomActivityCard
      }
      themes {
        id
        icon
        name
      }
      filterSetsGeneric {
        name
        slug
        filters {
          name
          slug
        }
      }
      filterSetsTheme(themeId: $filterThemeId) {
        name
        slug
        theme {
          icon
          name
        }
        filters {
          name
          slug
        }
      }
      activeFilters(filters: $filters, themeId: $filterThemeId) {
        activeFiltersTheme {
          name
          slug
          filterSet {
            name
            slug
            theme {
              icon
              name
            }
          }
        }
        activeFiltersGeneric {
          name
          slug
          filterSet {
            name
            slug
          }
        }
      }
    }
  `,
  { ActivityCard, Logo },
);
